import React, { Component } from "react";
import PropTypes from "prop-types";

import "../../../styles/components/utils/components/Carousel.scss";

class Carousel extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      items: [],
      selected: 0,
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hasOwnProperty("selected") && this.props.hasOwnProperty("selected"))
      if (prevProps.selected !== this.props.selected)
        this.safeSetState({ selected: this.props.selected });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      items: nextProps.items || [],
      selected: nextProps.selected || 0,
    };
  }

  switchSelected(direction) {
    const length = this.state.items.length;
    let index = this.state.selected;
    if (direction === "next") {
      index++;
      if (index === length) index = 0;
    } else if (direction === "prev") {
      index--;
      if (index < 0) index = length - 1;
    }

    this.safeSetState({ selected: index }, () =>
      this.props.onSelect(this.state.items[index], index)
    );

    if (this.props.fixSelected) {
      this.props.fixSelected();
    }
  }

  renderShownItems(shownIndexes, items) {
    for (let i = 0; i < shownIndexes.length; i++) {
      const idx = shownIndexes[i];
      items.push(
        <div
          className={"evio-carousel-item show " + (i === 1 ? "main" : i === 0 ? "left" : "right")}
          key={`${this.state.items[idx]._id || ""}.${i}`}
        >
          {this.props.energyManagementFlag ? 
            <div style={{display: "flex", backgroundColor: "grey", flex: 1}}></div>
          :
            <img
              src={
                `${this.state.items[idx].imageContent}?v=${Date.now()}` ||
                (this.props.hasOwnProperty("placeholder") && this.props.placeholder)
              }
              alt=""
            />
          }
          
          {i === 1 && (
            <div className="evio-carousel-item-caption">
              <p>{this.state.items[idx].name}</p>
            </div>
          )}
        </div>
      );
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const items = [];
    const length = this.state.items.length;
    let shownIndexes = [];
    for (let i = -1; i < 2; i++) {
      let idx = this.state.selected - i;
      if (idx < 0) idx = length - 1;
      if (idx === length) idx = 0;
      shownIndexes.push(idx);
    }

    if (length >= 3) {
      for (let i = 0; i < length; i++) {
        if (!shownIndexes.includes(i)) {
          items.push(
            <div className="evio-carousel-item" key={`${this.state.items[i]._id}.${i}`}>
              <img src={this.state.items[i].imageContent} alt="" />
              {i === this.state.selected && (
                <div className="evio-carousel-item-caption">
                  <h5>{this.state.items[i].name}</h5>
                </div>
              )}
            </div>
          );
        } else {
          if (i === shownIndexes[0]) this.renderShownItems(shownIndexes, items);
        }
      }
    } else if (length > 0 && length < 3) {
      this.renderShownItems(shownIndexes, items);
    }

    return (
      <div id="carousel" className="evio-carousel">
        <div className="evio-carousel-items">{items}</div>
        <div className="evio-carousel-controls">
          <button
            type="button"
            id="prev"
            className="clear"
            onClick={() => this.switchSelected("prev")}
          >
            <div className="evio-carousel-control-btn prev" />
          </button>
          <button
            type="button"
            id="next"
            className="btn-container clear"
            onClick={() => this.switchSelected("next")}
          >
            <div className="evio-carousel-control-btn next" />
          </button>
        </div>
      </div>
    );
  }
}

Carousel.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.number,
  energyManagementFlag: PropTypes.bool,
  fixSelected: PropTypes.func,
};

export default Carousel;
